import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import HeadTeacherDatatable from "../../components/datatable/HeadTeacherDatatable"

const List = () => {
  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar/>
        <HeadTeacherDatatable/>
      </div>
    </div>
  )
}

export default List